import{useThemeUI as r}from"theme-ui";var e=r;export{e as useTheme};
//# sourceMappingURL=use-theme.js.map
